export const FUNNELBACK_SEARCH = 'https://dfed-search.squiz.cloud/s/suggest.json';
export const FUNNELBACK_SEARCH_JSON = 'https://dfed-search.squiz.cloud/s/search.json';
export const LOCATIONSA_AUTOCOMPLETE = 'https://search.geohub.sa.gov.au/api/geocoder/pelias/locator/composite/autocomplete/';

export const DS_COLLECTION = {
    wowExp: 'experiences',
    employmentExp: 'experiences',
    workExp: 'experiences',
    volunteeringExp: 'experiences',
    qualifications: 'achievements',
    awards: 'achievements',
    educationCerts: 'education',
    portfolio: 'supplements'
}